module.exports = __webpack_public_path__ + "static/media/sass.c88a1a31.png";